<template>
  <div
    id="app">
    <router-view :key="$route.path"></router-view>

    <DropOverlay/>
    <DialogEnterLanguagePassword
      v-if="showPasswordPrompt"
      @ok="successfulLogin"/>
  </div>
</template>

<script>
import mixinLanguages from '@/mixins/languages'
import { EventBus } from '@/event-bus.js'
import DropOverlay from '@/components/basic/DropOverlay'
import DialogEnterLanguagePassword from '@/modules/languages/dialogs/EnterLanguagePassword'

export default {
  name: 'LanguagesApp',
  mixins: [mixinLanguages],
  components: {
    DropOverlay,
    DialogEnterLanguagePassword
  },
  data: () => ({
    showPasswordPrompt: false
  }),
  async mounted () {
    const savedToken = this.languagesGetToken()
    if (!savedToken) {
      this.askForPassword()
    } else {
      const passwordCheck = await this.languagesVerifyPassword(savedToken)
      if (!passwordCheck) {
        this.askForPassword()
      }
    }
  },
  methods: {
    askForPassword () {
      EventBus.$emit('overlayShow')
      this.$nextTick(() => {
        this.showPasswordPrompt = true
      })
    },
    successfulLogin () {
      EventBus.$emit('overlayHide')
      this.showPasswordPrompt = false
    }
  }
}
</script>

<style lang="scss">
@import "style/main";

.overlay.visible {
  background-color: rgba(255, 255, 255, 0.5) !important;
}

.flag {
  font-family: SourceSansProLight;
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: $size-grid * 2;
  height: $size-grid;
  margin: 1rem 0 1.5rem;
  cursor: pointer;
  color: $gray-medium;
  opacity: 0.25;
  pointer-events: none;

  &.available {
    opacity: 1;
    pointer-events: all;
  }

  &:hover {
    color: $cyan;
  }

  &:after {
    position: absolute;
    left: 0;
    bottom: -1.5rem;
    width: 100%;
    text-align: center;
    font-size: 1.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/AppLanguages.vue